// /**
//  * Minimal history (undo/redo) hook.
//  * Stores "present" state and two stacks; set(next, pushToUndo=true) mutates present.
//  */
// import { useCallback, useRef, useState } from 'react';
// export function useHistory<T>(initial: T, limit = 20) {
//   const [present, setPresent] = useState<T>(initial);
//   const undoStack = useRef<T[]>([]);
//   const redoStack = useRef<T[]>([]);
//   const set = useCallback(
//     (next: T, pushToUndo = true) => {
//       if (pushToUndo) {
//         undoStack.current.push(present);
//         if (undoStack.current.length > limit) undoStack.current.shift();
//         redoStack.current = [];
//       }
//       console.log('[useHistory] set', { next });
//       setPresent(next);
//     },
//     [present, limit],
//   );
//   const undo = useCallback(() => {
//     const prev = undoStack.current.pop();
//     if (prev !== undefined) {
//       redoStack.current.push(present);
//       setPresent(prev);
//     }
//   }, [present]);
//   const redo = useCallback(() => {
//     const nxt = redoStack.current.pop();
//     if (nxt !== undefined) {
//       undoStack.current.push(present);
//       setPresent(nxt);
//     }
//   }, [present]);
//   const reset = useCallback((next: T) => {
//     undoStack.current = [];
//     redoStack.current = [];
//     setPresent(next);
//   }, []);
//   return { state: present, set: setPresent, undo, redo, reset };
// }
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { useAtomCallback } from 'jotai/utils';
import { REDO, RESET, UNDO } from 'jotai-history';
import { useCallback } from 'react';
import { boardStateAtom, historyBoardStateAtom } from '@/store/boardAtoms';
export function useBoardHistory() {
    // текущее значение и обычный setter (любая запись пойдёт в историю)
    const [boardState, setBoardState] = useAtom(boardStateAtom);
    // действия истории и индикаторы
    const history = useAtomValue(historyBoardStateAtom);
    const setHistory = useSetAtom(historyBoardStateAtom);
    const undoBoardState = useCallback(() => setHistory(UNDO), [setHistory]);
    const redoBoardState = useCallback(() => setHistory(REDO), [setHistory]);
    const resetBoardState = useCallback((next) => {
        // очистить undo/redo
        setHistory(RESET);
        // при желании задать новое "present"
        if (arguments.length)
            setBoardState(next);
    }, [setHistory, setBoardState]);
    const undoWithSnapshots = useAtomCallback(useCallback((get, set) => {
        const before = get(boardStateAtom); // снимок ДО
        set(historyBoardStateAtom, UNDO); // откат
        const after = get(boardStateAtom); // снимок ПОСЛЕ
        return { before, after };
    }, []));
    const redoWithSnapshots = useAtomCallback(useCallback((get, set) => {
        const before = get(boardStateAtom);
        set(historyBoardStateAtom, REDO);
        const after = get(boardStateAtom);
        return { before, after };
    }, []));
    return {
        boardState,
        setBoardState, // (next) => void — записывает и пополняет историю
        undoBoardState,
        undoWithSnapshots,
        redoBoardState,
        redoWithSnapshots,
        resetBoardState,
        canUndo: history.canUndo,
        canRedo: history.canRedo,
    };
}
